export default {
  members: ({ members, filters: { status } }) => {
    let results = []

    if (status) {
      results = members[status]
    } else {
      results = [...members.active, ...members.inactive]
    }

    return results
  },
  membersWithoutFilters: state => [...state.members.active, ...state.members.inactive],
  isActive: state => member => {
    return state.members.active.some(m => m.email === member.email)
  },
  filters: state => state.filters,
  deactivating: state => state.member.deactivating,
  membersLoading: state => state.members.loading,
  member: state => state.member,
  totalMembers: state => state.members.totalMembers,
  filteredPage: state => state.members.page
}
